export default __webpack_public_path__ + "media/images/about-image-2-1f48399ff5d9cdbac8578826618738ba.jpg";